import { ConfigProvider } from 'antd';
import { FC, PropsWithChildren } from 'react';
import { appTheme } from '../../common/constants';

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  return <ConfigProvider theme={appTheme}>{children}</ConfigProvider>;
};
